import React from 'react';
import InfoTooltip from '../common/InfoTooltip';

const HOURS_TOOLTIP_TEXT =
  'Del inn denne delen av døgnet i ca klokkeslett, og tenk etter hvor mye av den tiden du har tilsyn eller hjelper. Hvis du er usikker, rund opp.';

/**
 * HelperFields - Who helps + hours input group
 *
 * Used at the bottom of each time-of-day step to capture:
 * - Primary helper (Mor, Far, Begge, Annen)
 * - Estimated hours of help
 */
export function HelperFields({
  helperValue,
  hoursValue,
  onHelperChange,
  onHoursChange,
  helperOptions = [
    { value: 'mor', label: 'Mor' },
    { value: 'far', label: 'Far' },
    { value: 'begge', label: 'Begge' },
    { value: 'annen', label: 'Annen' },
  ],
}) {
  return (
    <div className="mt-8 pt-6 border-t border-border-light">
      <h3 className="text-base font-semibold text-text-primary mb-4">
        Om hjelpen i denne perioden
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Helper dropdown */}
        <div>
          <label
            htmlFor="primary-helper"
            className="block text-sm font-medium text-text-secondary mb-2"
          >
            Hvem hjelper som oftest?
          </label>
          <select
            id="primary-helper"
            value={helperValue || ''}
            onChange={(e) => onHelperChange(e.target.value)}
            className="
              w-full p-3 rounded-lg
              border border-border-light
              bg-white
              text-text-primary
              focus:outline-none focus:ring-2 focus:ring-sage-300 focus:border-sage-400
              transition-all duration-200
              appearance-none
              cursor-pointer
            "
            style={{
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236E6960' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
              backgroundPosition: 'right 0.75rem center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '1.25rem 1.25rem',
              paddingRight: '2.5rem',
            }}
          >
            <option value="">Velg...</option>
            {helperOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* Hours input */}
        <div>
          <div className="flex items-center gap-2 mb-2">
            <label
              htmlFor="estimated-hours"
              className="block text-sm font-medium text-text-secondary"
            >
              Omtrent antall timer
            </label>
            <InfoTooltip text={HOURS_TOOLTIP_TEXT} label="Om antall timer" />
          </div>
          <input
            id="estimated-hours"
            type="number"
            min="0"
            max="24"
            step="0.5"
            value={hoursValue || ''}
            onChange={(e) => onHoursChange(e.target.value)}
            placeholder="f.eks. 2"
            className="
              w-full p-3 rounded-lg
              border border-border-light
              bg-white
              text-text-primary
              placeholder:text-text-muted
              focus:outline-none focus:ring-2 focus:ring-sage-300 focus:border-sage-400
              transition-all duration-200
            "
          />
        </div>
      </div>
    </div>
  );
}

export default HelperFields;
